var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Firebase from 'firebase/app';
import { AuthLoginCancelledError, getAuthSessionId } from '@/plugins/auth-storage';
import { ensureFirebaseAuthSession } from '@/plugins/firebase-auth-session';
import BaseApiClient from '@/plugins/apis/v2/base-api-client';
var DailyReportApiClient = /** @class */ (function (_super) {
    __extends(DailyReportApiClient, _super);
    function DailyReportApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailyReportApiClient.prototype.basePath = function (_a) {
        var projectId = _a.projectId, scheduleId = _a.scheduleId;
        var companyId = this.companyId;
        return "/companies/" + companyId + "/projects/" + projectId + "/schedules/" + scheduleId + "/daily_reports";
    };
    DailyReportApiClient.prototype.index = function (projectId, scheduleId, smallProcessId) {
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        var params = {
            small_process_id: smallProcessId
        };
        return client.get(url, { params: params });
    };
    DailyReportApiClient.prototype.show = function (projectId, scheduleId, dailyReportId) {
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/" + dailyReportId;
        return client.get(url);
    };
    DailyReportApiClient.prototype.create = function (projectId, scheduleId, smallProcessId, params, notice) {
        if (notice === void 0) { notice = false; }
        var requestAction = this.requestAction;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        return requestAction({
            url: url,
            data: {
                small_process_id: smallProcessId,
                daily_report: params
            },
            resourceName: 'daily_report',
            actionName: 'POST',
            notice: notice
        });
    };
    DailyReportApiClient.prototype.update = function (payload) {
        var requestAction = this.requestAction;
        var baseUrl = this.basePath({ projectId: payload.projectId, scheduleId: payload.scheduleId });
        var url = baseUrl + "/" + payload.id;
        var dailyReportParams = {
            body: payload.body,
            draft: payload.draft ? '1' : '0',
            construction_date: payload.construction_date,
            before_image_ids: payload.before_image_ids,
            after_image_ids: payload.after_image_ids
        };
        if (Number.isInteger(payload.progress)) {
            dailyReportParams.progress = payload.progress;
        }
        return requestAction({
            url: url,
            method: 'put',
            data: {
                small_process_id: payload.smallProcessId,
                daily_report: dailyReportParams
            },
            resourceName: 'update_daily_report',
            actionName: 'OTHER',
            notice: !payload.draft
        });
    };
    DailyReportApiClient.prototype.delete = function (projectId, scheduleId, smallProcessId, id) {
        var requestAction = this.requestAction;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/" + id;
        var params = {
            small_process_id: smallProcessId
        };
        return requestAction({
            url: url,
            method: 'delete',
            params: params,
            resourceName: 'daily_report',
            actionName: 'DELETE',
            notice: true
        });
    };
    DailyReportApiClient.prototype.getPreReport = function (_a) {
        var projectId = _a.projectId, scheduleId = _a.scheduleId, smallProcessId = _a.smallProcessId, constructionDate = _a.constructionDate;
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/pre_report";
        var params = {
            small_process_id: smallProcessId,
            construction_date: constructionDate
        };
        return client.get(url, { params: params });
    };
    DailyReportApiClient.prototype.generateSummary = function (_a) {
        var projectId = _a.projectId, daily_report_ids = _a.daily_report_ids;
        return __awaiter(this, void 0, Promise, function () {
            var sessionId, isCurrent, idToken, _b, client, companyId, url, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sessionId = getAuthSessionId();
                        isCurrent = function () { return sessionId === getAuthSessionId(); };
                        return [4 /*yield*/, this.getFirebaseIdToken(sessionId, isCurrent)];
                    case 1:
                        idToken = _c.sent();
                        if (!isCurrent())
                            throw new AuthLoginCancelledError();
                        _b = this, client = _b.client, companyId = _b.companyId;
                        url = "/companies/" + companyId + "/projects/" + projectId + "/daily_reports/generate_summary";
                        data = {
                            daily_report_ids: daily_report_ids,
                            id_token: idToken
                        };
                        return [2 /*return*/, client.post(url, data)];
                }
            });
        });
    };
    DailyReportApiClient.prototype.getFirebaseIdToken = function (sessionId, isCurrent) {
        return __awaiter(this, void 0, Promise, function () {
            var user, idToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ensureFirebaseAuthSession(Firebase.auth(), this.companyId, sessionId, isCurrent)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, user.getIdToken()];
                    case 2:
                        idToken = _a.sent();
                        if (!isCurrent())
                            throw new AuthLoginCancelledError();
                        return [2 /*return*/, idToken];
                }
            });
        });
    };
    return DailyReportApiClient;
}(BaseApiClient));
export default new DailyReportApiClient();
